module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jK9Vu"))).then(() => parcelRequire('hEqeo'));